var description = 'fx_2d2fb1e5_31khjb0';

export { description };
//# sourceMappingURL=description.vanilla.mjs.map
